"use strict";
var vec3 = require('gl-matrix/src/gl-matrix/vec3');
var v0 = vec3.create();
var v1 = vec3.create();
var emptyFunction = function () { return undefined; };
var AABB = (function () {
    function AABB(center, size, onMove) {
        if (onMove === void 0) { onMove = emptyFunction; }
        this.size = vec3.clone(size);
        this.base = vec3.create();
        this.center = vec3.clone(center);
        this.max = vec3.create();
        this.area = vec3.create();
        this.onMove = onMove;
        this.calculateSurfaceArea();
        this.calculateVertices();
    }
    AABB.prototype.width = function () {
        return this.size[0];
    };
    AABB.prototype.height = function () {
        return this.size[1];
    };
    AABB.prototype.depth = function () {
        return this.size[2];
    };
    AABB.prototype.x0 = function () {
        return this.base[0];
    };
    AABB.prototype.y0 = function () {
        return this.base[1];
    };
    AABB.prototype.z0 = function () {
        return this.base[2];
    };
    AABB.prototype.x1 = function () {
        return this.max[0];
    };
    AABB.prototype.y1 = function () {
        return this.max[1];
    };
    AABB.prototype.z1 = function () {
        return this.max[2];
    };
    AABB.prototype.setCenter = function (x, y, z) {
        vec3.set(this.center, x, y, z);
        return this.updateCenter();
    };
    AABB.prototype.copyCenter = function (center) {
        vec3.copy(this.center, center);
        return this.updateCenter();
    };
    AABB.prototype.translate = function (by) {
        vec3.add(this.max, this.max, by);
        vec3.add(this.center, this.center, by);
        vec3.add(this.base, this.base, by);
        this.onMove();
        return this;
    };
    AABB.prototype.copySize = function (size) {
        vec3.copy(this.size, size);
        this.calculateSurfaceArea();
        this.calculateVertices();
        return this;
    };
    AABB.prototype.expand = function (aabb) {
        var max = vec3.create();
        var min = vec3.create();
        vec3.max(max, aabb.max, this.max);
        vec3.min(min, aabb.base, this.base);
        vec3.subtract(max, max, min);
        return new AABB(min, max);
    };
    AABB.prototype.intersects = function (aabb) {
        if (aabb.base[0] > this.max[0])
            return false;
        if (aabb.base[1] > this.max[1])
            return false;
        if (aabb.base[2] > this.max[2])
            return false;
        if (aabb.max[0] < this.base[0])
            return false;
        if (aabb.max[1] < this.base[1])
            return false;
        if (aabb.max[2] < this.base[2])
            return false;
        return true;
    };
    AABB.prototype.touches = function (aabb) {
        var intersection = this.union(aabb);
        return (intersection !== null) &&
            ((intersection.width() === 0) ||
                (intersection.height() === 0) ||
                (intersection.depth() === 0));
    };
    AABB.prototype.union = function (aabb) {
        if (!this.intersects(aabb))
            return null;
        var baseX = Math.max(aabb.base[0], this.base[0]);
        var baseY = Math.max(aabb.base[1], this.base[1]);
        var baseZ = Math.max(aabb.base[2], this.base[2]);
        var maxX = Math.min(aabb.max[0], this.max[0]);
        var maxY = Math.min(aabb.max[1], this.max[1]);
        var maxZ = Math.min(aabb.max[2], this.max[2]);
        return new AABB(vec3.set(v0, baseX, baseY, baseZ), vec3.set(v1, maxX - baseX, maxY - baseY, maxZ - baseZ));
    };
    AABB.prototype.unionSize = function (out, aabb) {
        var min = vec3.max(v0, aabb.base, this.base);
        var max = vec3.min(v1, aabb.max, this.max);
        return vec3.sub(out, max, min);
    };
    AABB.prototype.updateCenter = function () {
        this.calculateVertices();
        this.onMove();
        return this;
    };
    AABB.prototype.calculateSurfaceArea = function () {
        vec3.set(this.area, this.size[1] * this.size[2], this.size[2] * this.size[0], this.size[0] * this.size[1]);
    };
    AABB.prototype.calculateVertices = function () {
        var sizeHalf = vec3.scale(v0, this.size, 0.5);
        vec3.sub(this.base, this.center, sizeHalf);
        vec3.add(this.max, this.center, sizeHalf);
    };
    return AABB;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AABB;
//# sourceMappingURL=AABB.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/physics/lib/AABB.js
 ** module id = 411
 ** module chunks = 0
 **/